/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIImage
 */
export interface AIImage {
    /**
     * 
     * @type {string}
     * @memberof AIImage
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof AIImage
     */
    asset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AIImage
     */
    proxy?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AIImage
     */
    frame: number;
    /**
     * 
     * @type {string}
     * @memberof AIImage
     */
    filename?: string;
    /**
     * 
     * @type {string}
     * @memberof AIImage
     */
    dataset: string;
    /**
     * 
     * @type {number}
     * @memberof AIImage
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof AIImage
     */
    height: number;
}

export function AIImageFromJSON(json: any): AIImage {
    return AIImageFromJSONTyped(json, false);
}

export function AIImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'proxy': !exists(json, 'proxy') ? undefined : json['proxy'],
        'frame': json['frame'],
        'filename': !exists(json, 'filename') ? undefined : json['filename'],
        'dataset': json['dataset'],
        'width': json['width'],
        'height': json['height'],
    };
}

export function AIImageToJSON(value?: AIImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'asset': value.asset,
        'proxy': value.proxy,
        'frame': value.frame,
        'filename': value.filename,
        'dataset': value.dataset,
        'width': value.width,
        'height': value.height,
    };
}


